import { Book } from "@faire/web--source/slate/icons/foundation/Book";
import { ThumbsUp } from "@faire/web--source/slate/icons/foundation/ThumbsUp";
import { Row } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import * as React from "react";

export const AcademyGuideSummaryText: React.FC<{
  numChapters: number;
  readTimeMinutes: number;
  likes: number | undefined;
}> = ({ numChapters, readTimeMinutes, likes }) => {
  return (
    <Row gap="1x" align="center">
      <Book />
      <Typography>
        <StrictLocalMsg
          defaultMessage="{chaptersCountNumber, plural, one {# chapter} other {# chapters}}"
          description={{
            text: "Indicating the number of chapters in an educational guide",
            img: "https://cdn.faire.com/fastly/35ddd722e22a8b434fe8bb01ff7242afdbe6e6d3a73719af7c2e1d54d098a475.png",
          }}
          values={{ chaptersCountNumber: numChapters }}
        />
        {" · "}
        <StrictLocalMsg
          defaultMessage="{readTimeMinutesNumber, plural, one {# min} other {# mins}}"
          description={{
            text: "Indicating the estimated time it takes to read an educational guide",
            img: "https://cdn.faire.com/fastly/35ddd722e22a8b434fe8bb01ff7242afdbe6e6d3a73719af7c2e1d54d098a475.png",
          }}
          values={{ readTimeMinutesNumber: readTimeMinutes }}
        />
      </Typography>
      {likes && likes > 0 ? (
        <>
          <ThumbsUp />
          <Typography>
            <StrictLocalMsg
              defaultMessage="{guideLikesNumber, plural, one {# like} other {# likes}}"
              description={{
                text: "Indicating the number of times a guide page has been liked",
                img: "https://cdn.faire.com/fastly/35ddd722e22a8b434fe8bb01ff7242afdbe6e6d3a73719af7c2e1d54d098a475.png",
              }}
              values={{ guideLikesNumber: likes }}
            />
          </Typography>
        </>
      ) : null}
    </Row>
  );
};
